<template>
    <div class="bottomCont">
        <!-- 官网底部 -->
        <footer class="footer">
            <!-- 上半部分 -->
            <div class="footer-top">
                <div class="footer-item">
                    <div class="item-title">{{ $t('footer.localWebsites.title') }}</div>
                    <ul>
                        <!-- 根据客户需求只显示巴西 由于与地图使用的数据一致 在此判断 -->
                        <li v-for="(item, index) in locationsList[0]?.value[0].content" :key="index" v-if="item.name.includes('Brazil')">
                            <a :href="item.url" target="_blank">{{ item.name }}</a>
                        </li>
                        <li>
                            <span>{{ $t('new.bottomText') }}</span>
                        </li>
                    </ul>
                </div>
                <div class="footer-item">
                    <div class="item-title">{{ $t('footer.info.title') }}</div>
                    <ul>
                        <!-- 根据客户需求只显示Privacy Policy 不动数据 判断 -->
                        <li v-for="(item, index) in $t('footer.info.list')" v-if="item.title.includes('Privacy')" :key="index">
                            <router-link to="/privacy" style="text-decoration: none;">
                                <span>{{ item.title }}</span>
                            </router-link>
                            <!-- <a :href="item.toLink" target="_blank">{{ item.title }}</a> -->
                        </li>
                    </ul>
                </div>
                <div class="footer-item">
                    <div class="item-title" style="padding-left: 10px;">{{ $t('new.getConnected') }}</div>
                    <div class="social-links">
                        <a :href="config?.instagram" target="_blank">
                            <img src="@/assets/assetsNew/footer/instagram.png" alt="">
                        </a>
                        <a :href="config?.twitter" class="social-break" target="_blank">
                            <img src="@/assets/assetsNew/footer/tiktok.png" alt="">
                        </a>
                        <a :href="config?.facebook" target="_blank">
                            <img src="@/assets/assetsNew/footer/facebook.png" alt="">
                        </a>
                        <a :href="config?.linkedIn" target="_blank">
                            <img src="@/assets/assetsNew/footer/linkedin.png" alt="">
                        </a>
                        
                    </div>
                </div>
                <div class="footer-item">
                    <div class="item-title">{{ $t('footer.contact.title') }}</div>
                    <div class="contact-info">
                        <h6>{{ config?.address }}</h6>
                        <h6>{{ config?.mobile }}</h6>
                        <!-- info@komowellness.com -->
                        <h6 style="margin-top: 1em">{{ config?.email }}</h6>
                    </div>
                </div>
            </div>
            <!-- 下半部分 -->
            <div class="footer-bottom">
                <p>{{ $t('footer.contact.copyright') }}</p>
            </div>
        </footer>
    </div>
</template>

<script>
import { getDataList } from '@/api/komo'
import { getConfigInformation } from '@/api/komo'
export default {
    name: 'bottomCont',
    data() {
        return {
            config: {},
            locationsList:{}
        }
    },
    async created() {
        await this.initData();
    },
    methods: {
        async initData() {
            const result = await getConfigInformation();
            this.config = result.data;
            const locationsDatalist = await getDataList('6');
            this.locationsList = locationsDatalist.data.list;
        }
    }
}
</script>

<style scoped>
.bottomCont {
    width: 100%;
    height: 100%;
    color: #fff;
    position: relative;

}

.footer {
    width: 100%;
    /* height: 352px; */
    background-color: #64715d;
}

.footer-top {
    width: 100%;
    height: 288px;
    padding: 60px;
    display: flex;
    /* align-items: center; */

}

.footer-item {
    flex: 1;
}

.item-title {
    font-size: 18px;
    color: #e8e2d9;
    font-family: serif;
    font-weight: 400;
}

.footer-item ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
}


.footer-item a {
    text-decoration: none;
    color: #e8e2d9;
    font-size: 15px;
    font-family: "Inter", sans-serif;
    display: inline-block;
    position: relative;

}
.footer-item span {
    text-decoration: none;
    color: #e8e2d9;
    font-size: 15px;
    font-family: "Inter", sans-serif;
    display: inline-block;
    position: relative;

}

/* 字体下方横线动画 */
.footer-item a::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 1px;
    width: 0;
    background: #e8e2d9;
    transition: width .3s ease;

}

.footer-item a:hover::after {
    width: 100%;
    /* 悬停时展开 */
}

.social-links {
    display: flex;
    gap: 10px;
    align-items: center;
}

.social-links a {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

}

.social-links a::after {
    display: none;
    /* 保险起见，直接不让伪元素出现 */
}

.social-links img {
    width: 20px;
    height: 20px;
}

.contact-info h6 {
    color: #e8e2d9;
    font-size: 16px;
    font-family: "Crimson Text", serif;
    /* font-weight: 400; */
}

.footer-bottom {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.footer-bottom p {
    color: #e8e2d9;
    font-size: 10px;
}

@media (max-width: 875px) {
  
}

@media (max-width: 768px) {
    .footer-top {
        height: 608px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-left: 15px;
        padding-right: 15px;
    }

    .footer-item {
        width: 100%;
        text-align: center;
    }

    .social-links {
        justify-content: center;
    }
}
</style>
